
// const API_loadUmooveLibrary = (vidWidth = 960, vidHeight = 720) => {
//   videoWidth = vidWidth;
//   return new Promise((resolve, reject) => {
//     window
//       .loadUmooveLibrary(vidWidth, vidHeight)
//       .then((stream) => {
//         window.initUmoove();
//         resolve(stream);
//       })
//       .catch((e) => reject(e));
//   });

import { calcWPM } from "../../dataForAnalized3";

// };

// UmoovePluginShowPreview
// UmoovePluginHidePreview
// UmoovePluginStart
// UmoovePluginStop
const API_loadUmooveLibrary = (vidWidth = 960, vidHeight = 720) => {
  if (window.cordovaOn) {
    // alert("API_loadUmooveLibrary")
    console.log("umPlufCallInit")
    window.UmoovePluginInit();
  } else {
    // videoWidth = vidWidth;
    const primeryVideoElement = document.getElementById("video")
    return new Promise((resolve, reject) => {
      window.umooveAPI.init()
        .then(() => {
          return API_openCamera(primeryVideoElement, vidWidth, vidHeight);
        })
        .then((stream) => {
          window.umooveAPI.setSrc(primeryVideoElement, window.newUmooveData);
          // primeryVideoElement.style.display = "block";
          resolve(stream);
        })
        .catch((e) => reject(e));
    });
  }
};

const API_getUmooveStream = () => {
  if (window.UMStream) {
    return window.UMStream;
  } else {
    return false;
  }
};
const API_getAlignment = () => {

  let alignmentThreshholdCM = 5.0;
  let UMheadPos = window.UMheadPos;
  let diam = window.UMDiam;
  let FOV_H = 58.5;
  let degreesToRadians = 0.0174533;
  let detectedDistance =
    ((1.18 / diam) * (window.videoWidth / 2.0)) /
    Math.tan((FOV_H / 2.0) * degreesToRadians);
  let center = { x: window.videoWidth / 2, y: window.videoHeight / 2 };
  let alignmentThreshhold = (diam / 1.18) * alignmentThreshholdCM;

  let diff = window.cordovaOn ? (UMheadPos.x - center.x) * -1 : (UMheadPos.x - center.x);
  console.log('diff', diff, 'headPOsX', UMheadPos.x, 'center', center.x, "alignmentThreshhold:", alignmentThreshhold);
  if (!isNaN(diff)) {
    if (Math.abs(diff) > alignmentThreshhold && alignmentThreshhold !== 0) {
      return diff > 0 ? { align: 1, TH: alignmentThreshhold } : { align: -1, TH: alignmentThreshhold };
    } else {
      return { align: 0, TH: alignmentThreshhold };
    }
  } else {
    return { align: 0, TH: alignmentThreshhold };
  }
  //returns -1 0 1
};

// const API_startUmoove = () => {
//   window.startUmoove(true);
// };
const API_startUmoove = (showVideo = true) => {
  if (window.cordovaOn) {
    window.UmoovePluginStart(showVideo);
  } else {
    window.umooveAPI.start(true, "both");
  }
};

// const API_stopUmoove = () => {
//   window.stopUmoove();
//   if (window.UMStream) {
//     window.UMStream.getTracks().forEach(function (track) {
//       track.stop();
//     });
//   }
// };

const API_stopUmoove = async (shutDownCam = true) => {

  console.log("🚀 ~ file: UmooveApi.js:101 ~ window.cordovaOn:", window.cordovaOn)
  if (window.cordovaOn) {
    window.UmoovePluginStop(true)
  } else {

    const primeryVideoElement = document.getElementById("video")

    window.umooveAPI.stop();
    if (window.UMStream && shutDownCam) {
      window.UMStream.getTracks().forEach(function (track) {
        track.stop();
      });
      window.UMStream = null;
      window.clearData()
      // primeryVideoElement.style.display = "none"//TODO: iphone only
      API_exitFullScreenMode()//TODO: in debug only???
      return
    }
  }
};
const API_getDistance = () => {
  let diam = window.UMDiam;
  let FOV_H = 42;
  // let videoWidth = 960;
  let degreesToRadians = 0.0174533;
  let detectedDistance =
    ((1.18 / diam) * (window.videoWidth / 2.0)) /
    Math.tan((FOV_H / 2.0) * degreesToRadians);
  if (diam !== 0 && (window.UMFaceState === 2 || window.UMFaceState == true)) {
    return detectedDistance;
  } else return -1;
};
const API_getUmooveTracking = () => {
  if (window.UMFaceState == 2 || window.UMFaceState) {
    return true;
  } else return false;
};
const API_startReading = () => {
  window.collectData = true;
};
const API_stopReading = (examData) => {
  console.log("🚀 ~ file: UmooveApi.js:116 ~ examData:", examData)
  //Stop the collection
  window.collectData = false;
  let readingdataArray = window.readingData;
  console.log(readingdataArray);
  let combinedIrisPosXMove = readingdataArray.map(move => { return { x: move.eye_data[3], TS: move.time } });
  let posXL = readingdataArray.map(move => { return { x: move.eye_data[8], TS: move.time } });
  let posXR = readingdataArray.map(move => { return { x: move.eye_data[10], TS: move.time } });
  //reset the array and vars
  let AvgNStd = calcWPM(combinedIrisPosXMove, examData.lines);
  window.readingData = [];
  API_stopUmoove();
  ///deal with the data and stop collect + reset the reading data array
  window.debuggCollector("stopReadingData", { results: AvgNStd, linesData: examData.lines, combinedIrisPosXMove, posXL, posXR })

  return AvgNStd
  //Defining thresholds and counters
  let lineBreakThreshold = -0.08;
  let stackMaxLength = 4;
  let stack = [];
  let timeStampPerLines = [];
  let timePerLine = [];
  let initialGap = 0;
  let doSearchGap = true;
  timeStampPerLines.push(readingdataArray[0].time);
  // ...?
  for (let index = 0; index < readingdataArray.length; index++) {
    const eyeDataCombined = readingdataArray[index].eye_data[3];
    const eyeDataTimestamp = readingdataArray[index].time;
    ///Stack 4
    if (stack.length === stackMaxLength) {
      stack.shift();
    }
    stack.push({ data: eyeDataCombined, index: index });
    ////+-+-+-+-////

    if (stack.length > stackMaxLength - 1) {
      let first = stack[0];
      let last = stack[stack.length - 1];
      let testGap = last.data - first.data;

      if (doSearchGap) {
        if (initialGap == 0 && testGap < lineBreakThreshold) {
          initialGap = testGap;
        } else if (initialGap != 0 && testGap <= initialGap) {
          initialGap = testGap;
        } else if (initialGap != 0) {
          initialGap = 0;
          timeStampPerLines.push({
            endPrev: readingdataArray[Math.max(0, index - 1 - stackMaxLength)].time,
            startNext: readingdataArray[index].time,
          });
          doSearchGap = false;
        }
      } else {
        if (testGap > 0) doSearchGap = true;
      }
    }
  }
  // timeStampPerLines.pop();
  timeStampPerLines.shift();
  console.log(timeStampPerLines);

  for (let index = 1; index < timeStampPerLines.length; index++) {
    const line_time =
      timeStampPerLines[index].endPrev - timeStampPerLines[index - 1].startNext;
    timePerLine.push(line_time);
  }
  console.log("results", timePerLine);

  //reset the array and vars
  window.readingData = [];
  API_stopUmoove();
  return timePerLine;
};


function API_openCamera(videoElement, vidWidth = 960, vidHeight = 720) {
  return new Promise(async (resolve, reject) => {
    if (window.UMStream) {
      window.UMStream.getTracks().forEach(function (track) {
        track.stop();
      });

    }
    try {
      let isMobile = API_isMobile();
      // alert(isMobile)
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
          //in mobile it need to be reversed; TODO: in debug only???
          height: { min: vidHeight, max: vidHeight },
          width: { min: vidWidth, max: vidWidth },
          //frameRate: { min: 15, ideal: 28, max: 30 },
          facingMode: "user",
        },
      });
      window.UMStream = stream;
      videoElement.srcObject = stream;
      videoElement.setAttribute('autoplay', '');
      videoElement.setAttribute('muted', '');
      videoElement.setAttribute('playsinline', '');
      API_fullScreenMode()//TODO: in debug only???
      resolve(stream); // Resolve the Promise if everything is successful
    } catch (err) {
      console.log("An error occurred! " + err);
      reject(err); // Reject the Promise if an error occurs
    }
  });
}

function API_fullScreenMode() {
  return
  if (document.documentElement.requestFullscreen) {
    // Enter fullscreen mode
    document.documentElement.requestFullscreen();
  } else if (document.documentElement.mozRequestFullScreen) { // Firefox
    document.documentElement.mozRequestFullScreen();
  } else if (document.documentElement.webkitRequestFullscreen) { // Chrome, Safari and Opera
    document.documentElement.webkitRequestFullscreen();
  } else if (document.documentElement.msRequestFullscreen) { // Internet Explorer and Edge
    document.documentElement.msRequestFullscreen();
  }
}

function API_exitFullScreenMode() {
  return
  // Exit fullscreen mode
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) { // Firefox
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) { // Internet Explorer and Edge
    document.msExitFullscreen();
  }
}


function API_isMobile() {
  // Check if the user agent indicates a mobile device
  // const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && navigator.maxTouchPoints;
  // const hasMouseEvents = window;
  // console.log("🚀 ~ file: UmooveApi.js:241 ~ API_isMobile ~ hasMouseEvents:", hasMouseEvents)


  // if (isMobile) {
  //   // Code to run when accessing from a mobile device
  //   console.log('Mobile device detected');
  // } else {
  //   // Code to run when accessing from a desktop computer
  //   console.log('Desktop computer detected');
  // }
  // Check if the platform indicates a mobile device
  const isMobile = !/Win/i.test(navigator.platform);

  if (isMobile) {
    // Code to run when accessing from a mobile device
    console.log('Mobile device detected');
  } else {
    // Code to run when accessing from a desktop computer
    console.log('Desktop computer detected');
  }

  return isMobile
}

const UmooveApi = {
  API_loadUmooveLibrary,
  API_getUmooveStream,
  API_startUmoove,
  API_stopUmoove,
  API_getDistance,
  API_getUmooveTracking,
  API_startReading,
  API_stopReading,
  API_getAlignment,
};
export default UmooveApi;